import {
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  Link,
  Typography,
  useTheme
} from "@mui/material";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import {
  BCPArrowLeft,
  BCPChartMixed,
  BCPCircleInfo,
  BCPPen,
  BCPUserGroup
} from "../../../components/icons/bcp/BCPIcons";
import Hero from "../../../components/layout/Hero";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import EventInfoOverview from "./EventInfo/components/EventInfoOverview";

const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

export default function EventInfo(props) {
  const {
    // organize,
    event,
    handleTabChange
  } = props;

  const theme = useTheme();
  const navigate = useNavigate();

  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventInfo"
  });

  const overviewButtonSx = {
    color: theme.palette.secondary.contrastText,

    backgroundColor: theme.palette.secondary.main,
    textTransform: "none",
    fontWeight: "600",
    fontSize: "18px",
    "&:hover": {
      backgroundColor: `${theme.palette.text.disabled} !important`,
      color: `${theme.palette.secondary.contrastText} !important`
    }
  };

  const otherButtonSx = {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.main,
    textTransform: "none",
    fontWeight: "600",
    fontSize: "18px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };

  if (!event) return <ModalLoadingFull sx={{ zIndex: 1 }} />;

  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid
            item
            xs={7}
            sx={{
              display: "flex",
              alignItems: "center"
            }}
          >
            <Link
              href="/organize/events"
              color="link.main"
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start"
              }}
            >
              <BCPArrowLeft
                sx={{ "padding-right": "1rem", "padding-bottom": "2px" }}
              />{" "}
              Back to Managed Events
            </Link>
          </Grid>

          <Hidden mdUp>
            <Grid item xs={5}>
              <Button
                variant="contained"
                fullWidth
                startIcon={<BCPPen />}
                onClick={(e) => {
                  if (handleTabChange) {
                    handleTabChange(e, 6);
                  } else {
                    navigate(
                      `/organize/event/${event?.id}?active_tab=info&comp=details`,
                      {
                        replace: true
                      }
                    );
                  }
                }}
              >
                {t("editEvent")}
              </Button>
            </Grid>
          </Hidden>

          <Grid item xs={12} sx={{ mt: 2 }}>
            <Hero
              backgroundImage={
                event
                  ? event?.photoUrl ||
                    event?.photo?.url ||
                    `${SYSTEM_IMAGES_CLOUDFRONT}/images/EventImage${
                      theme.palette.mode === "dark" ? "Dark" : ""
                    }.png`
                  : ""
              }
              sxBackground={{
                height: ["unset", "20vh"],
                maxHeight: ["unset", "600px"],
                minHeight: "200px",
                color: "common.white",
                borderRadius: "4px"
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="h2"
              gutterBottom
              component="h3"
              fontWeight="700"
            >
              {event?.name || "Event Overview"}
            </Typography>
            {(event?.gameSystemName || event?.gameSystem?.name) && (
              <Typography variant="h3" gutterBottom>
                {event?.gameSystemName || event?.gameSystem?.name}
              </Typography>
            )}
          </Grid>

          {/* Tabs */}
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              mb: 2
            }}
          >
            <Box sx={{ display: "flex", gap: [1, 2], flexWrap: "wrap" }}>
              <Button
                sx={overviewButtonSx}
                startIcon={<BCPCircleInfo size={20} />}
                href={`/organize/event/${event?.id}?active_tab=info`}
              >
                {t("overview")}
              </Button>
              <Button
                sx={otherButtonSx}
                startIcon={<BCPUserGroup size={20} />}
                href={`/organize/event/${event?.id}?active_tab=roster`}
              >
                {t("playersAndLists")}
              </Button>
              <Button
                sx={otherButtonSx}
                startIcon={<BCPChartMixed size={20} />}
                href={`/organize/event/${event?.id}?active_tab=placings`}
              >
                {t("leaderboard")}
              </Button>
            </Box>
            <Hidden mdDown>
              <Button
                variant="contained"
                startIcon={<BCPPen size={20} />}
                onClick={(e) => {
                  if (handleTabChange) {
                    handleTabChange(e, 6);
                  } else {
                    navigate(
                      `/organize/event/${event?.id}?active_tab=info&comp=details`,
                      {
                        replace: true
                      }
                    );
                  }
                }}
              >
                {t("editEvent")}
              </Button>
            </Hidden>
          </Grid>

          <Grid item xs={12}>
            <EventInfoOverview event={event} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
